import React from 'react';
import PropTypes from 'prop-types';

export default function IcDotPdf({ className }) {
  return (
    <svg className={className} fill="none" height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_8538_107676)">
        <path d="M10 7C10 5.89543 10.8954 5 12 5H41L50 14V53C50 54.1046 49.1046 55 48 55H12C10.8954 55 10 54.1046 10 53V7Z" fill="url(#paint0_linear_8538_107676)"/>
      </g>
      <path d="M50 14L41 5V11C41 12.6569 42.3431 14 44 14H50Z" fill="#AFAAFF"/>
      <g filter="url(#filter1_ii_8538_107676)">
        <rect fill="#F21116" height="18" rx="2" width="46" x="7" y="23"/>
      </g>
      <g filter="url(#filter2_d_8538_107676)">
        <path d="M36.6377 37V26.4546H43.6199V28.2928H38.8673V30.8056H43.1565V32.6439H38.8673V37H36.6377Z" fill="white"/>
        <path d="M29.8267 37H26.0884V26.4546H29.8576C30.9183 26.4546 31.8314 26.6657 32.5969 27.0879C33.3624 27.5067 33.9511 28.1092 34.3631 28.8953C34.7784 29.6814 34.9861 30.622 34.9861 31.717C34.9861 32.8155 34.7784 33.7595 34.3631 34.5491C33.9511 35.3386 33.359 35.9445 32.5866 36.3667C31.8177 36.7889 30.8977 37 29.8267 37ZM28.318 35.0897H29.734C30.3931 35.0897 30.9475 34.973 31.3972 34.7396C31.8503 34.5027 32.1901 34.1371 32.4167 33.6428C32.6467 33.145 32.7617 32.5031 32.7617 31.717C32.7617 30.9378 32.6467 30.301 32.4167 29.8067C32.1901 29.3124 31.852 28.9485 31.4023 28.7151C30.9526 28.4816 30.3982 28.3649 29.7391 28.3649H28.318V35.0897Z" fill="white"/>
        <path d="M16.7002 37V26.4546H20.8607C21.6605 26.4546 22.3419 26.6073 22.9049 26.9129C23.4679 27.2149 23.897 27.6355 24.1922 28.1744C24.4909 28.7099 24.6402 29.3278 24.6402 30.0281C24.6402 30.7284 24.4891 31.3463 24.1871 31.8818C23.885 32.4173 23.4473 32.8344 22.874 33.133C22.3042 33.4317 21.6142 33.581 20.8041 33.581H18.1523V31.7943H20.4436C20.8727 31.7943 21.2263 31.7205 21.5044 31.5728C21.7858 31.4218 21.9952 31.2141 22.1325 30.9498C22.2733 30.682 22.3437 30.3748 22.3437 30.0281C22.3437 29.678 22.2733 29.3724 22.1325 29.1115C21.9952 28.8472 21.7858 28.643 21.5044 28.4988C21.2229 28.3512 20.8659 28.2774 20.4333 28.2774H18.9298V37H16.7002Z" fill="white"/>
      </g>
      <defs>
        <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="50" id="filter0_i_8538_107676" width="40" x="10" y="5">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape"/>
          <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.836314 0 0 0 0 0.832112 0 0 0 0 0.983393 0 0 0 1 0"/>
          <feBlend in2="shape" mode="normal" result="effect1_innerShadow_8538_107676"/>
        </filter>
        <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="18.3" id="filter1_ii_8538_107676" width="46" x="7" y="23">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape"/>
          <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="0.3"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend in2="shape" mode="normal" result="effect1_innerShadow_8538_107676"/>
          <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="0.1"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.999906 0 0 0 0 0.999906 0 0 0 0 0.999906 0 0 0 0.25 0"/>
          <feBlend in2="effect1_innerShadow_8538_107676" mode="normal" result="effect2_innerShadow_8538_107676"/>
        </filter>
        <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="12.5454" id="filter2_d_8538_107676" width="28.9199" x="15.7002" y="25.9546">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="0.5"/>
          <feGaussianBlur stdDeviation="0.5"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_8538_107676"/>
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_8538_107676" mode="normal" result="shape"/>
        </filter>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_8538_107676" x1="30" x2="30" y1="5" y2="55">
          <stop stopColor="#E3E5FF"/>
          <stop offset="1" stopColor="#D4D2F9"/>
        </linearGradient>
      </defs>
    </svg>
  );
}

IcDotPdf.propTypes = {
  className: PropTypes.string,
};
